var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"svg-icon svg-icon-sm"},[_c('inline-svg',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: _vm.tip, placement: 'top', boundary: 'window' }),expression:"{ title: tip, placement: 'top', boundary: 'window' }"}],attrs:{"src":"/assets/svg/question-circle-fill.svg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }